const buttonFadeDurationMs = 100;
const container = "_35sc1dik8en";
const scrollButton = "_35ss1d2rure";
const scroller = "_35ssezy6uw";
const label = "_35sl6ii11i";

export { buttonFadeDurationMs, container, label, scrollButton, scroller };
import "./molecule.dropzones.style.linaria.module.css";
//# sourceMappingURL=molecule.dropzones.style.js.map
